export default __webpack_public_path__ + "static/project-slide-3-992-765-1e4e61e5a362b9e4d3abb67bcafc28a2.jpg";